@switch(theme()) {
  @case ('dark') {
    <span [ngClass]="{
      'text-primary': isSelected(),
      'font-bold': isSelected(),
      'text-default-light': !isSelected(),
      'font-semibold': !isSelected()
    }" class="line-clamp-2 text-xs tracking-tighter transition-all">{{text()}}</span>
  }
  @case ('light') {
    <span [ngClass]="{
      'text-default-light': isSelected(),
      'font-semibold': isSelected(),
      'text-white': !isSelected(),
      'font-medium': !isSelected()
    }" class="line-clamp-2 text-xs tracking-tighter transition-all">{{text()}}</span>
  }
}
